import type { Template } from "@/types";

export const LA_06_H0_V6: Template[] = [
{
    id: "la-06-h0v6-01",
    name: "LA 01 - H0V6",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-06-h0_v6_01.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 125, y: 48, width: 247, height: 380, rotation: 0, imageRotation: 0 },
            { id: "2", x: 380, y: 48, width: 132, height: 186, rotation: 0, imageRotation: 0 },
            { id: "3", x: 380, y: 241, width: 132, height: 186, rotation: 0, imageRotation: 0 },
            { id: "4", x: 763, y: 48, width: 246, height: 380, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1017, y: 48, width: 132, height: 186, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1017, y: 241, width: 132, height: 186, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-06-h0v6-02",
    name: "LA 02 - H0V6",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-06-h0_v6_02.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 125, y: 48, width: 135, height: 186, rotation: 0, imageRotation: 0 },
            { id: "2", x: 125, y: 241, width: 135, height: 186, rotation: 0, imageRotation: 0 },
            { id: "3", x: 268, y: 48, width: 244, height: 380, rotation: 0, imageRotation: 0 },
            { id: "4", x: 763, y: 48, width: 246, height: 380, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1017, y: 48, width: 132, height: 186, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1017, y: 241, width: 132, height: 186, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-06-h0v6-03",
    name: "LA 03 - H0V6",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-06-h0_v6_03.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 101, y: 76, width: 214, height: 322, rotation: 0, imageRotation: 0 },
            { id: "2", x: 322, y: 76, width: 213, height: 322, rotation: 0, imageRotation: 0 },
            { id: "3", x: 774, y: 48, width: 246, height: 380, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1027, y: 48, width: 95, height: 122, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1027, y: 177, width: 95, height: 121, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1027, y: 307, width: 95, height: 121, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-06-h0v6-04",
    name: "LA 04 - H0V6",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-06-h0_v6_04.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 40, y: 102, width: 181, height: 272, rotation: 0, imageRotation: 0 },
            { id: "2", x: 228, y: 102, width: 181, height: 272, rotation: 0, imageRotation: 0 },
            { id: "3", x: 417, y: 102, width: 180, height: 272, rotation: 0, imageRotation: 0 },
            { id: "4", x: 678, y: 102, width: 181, height: 272, rotation: 0, imageRotation: 0 },
            { id: "5", x: 866, y: 102, width: 180, height: 272, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1054, y: 102, width: 180, height: 272, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-06-h0v6-05",
    name: "LA 05 - H0V6",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-06-h0_v6_05.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 0, y: 88, width: 206, height: 301, rotation: 0, imageRotation: 0 },
            { id: "2", x: 214, y: 88, width: 206, height: 301, rotation: 0, imageRotation: 0 },
            { id: "3", x: 428, y: 88, width: 206, height: 301, rotation: 0, imageRotation: 0 },
            { id: "4", x: 642, y: 88, width: 206, height: 301, rotation: 0, imageRotation: 0 },
            { id: "5", x: 856, y: 88, width: 205, height: 301, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1069, y: 88, width: 205, height: 301, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-06-h0v6-06",
    name: "LA 06 - H0V6",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-06-h0_v6_06.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 40, y: 177, width: 181, height: 262, rotation: 0, imageRotation: 0 },
            { id: "2", x: 228, y: 177, width: 180, height: 262, rotation: 0, imageRotation: 0 },
            { id: "3", x: 416, y: 177, width: 180, height: 262, rotation: 0, imageRotation: 0 },
            { id: "4", x: 677, y: 177, width: 181, height: 262, rotation: 0, imageRotation: 0 },
            { id: "5", x: 865, y: 177, width: 180, height: 262, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1053, y: 177, width: 180, height: 262, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-06-h0v6-07",
    name: "LA 07 - H0V6",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-06-h0_v6_07.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 0, y: 0, width: 341, height: 476, rotation: 0, imageRotation: 0 },
            { id: "2", x: 491, y: 36, width: 143, height: 199, rotation: 0, imageRotation: 0 },
            { id: "3", x: 491, y: 242, width: 143, height: 199, rotation: 0, imageRotation: 0 },
            { id: "4", x: 642, y: 36, width: 143, height: 199, rotation: 0, imageRotation: 0 },
            { id: "5", x: 642, y: 242, width: 143, height: 199, rotation: 0, imageRotation: 0 },
            { id: "6", x: 933, y: 0, width: 341, height: 476, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-06-h0v6-08",
    name: "LA 08 - H0V6",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-06-h0_v6_08.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 0, y: 0, width: 343, height: 476, rotation: 0, imageRotation: 0 },
            { id: "2", x: 412, y: 36, width: 153, height: 198, rotation: 0, imageRotation: 0 },
            { id: "3", x: 412, y: 241, width: 153, height: 198, rotation: 0, imageRotation: 0 },
            { id: "4", x: 711, y: 36, width: 153, height: 198, rotation: 0, imageRotation: 0 },
            { id: "5", x: 711, y: 241, width: 153, height: 198, rotation: 0, imageRotation: 0 },
            { id: "6", x: 931, y: 0, width: 343, height: 476, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-06-h0v6-09",
    name: "LA 09 - H0V6",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-06-h0_v6_09.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 64, y: 71, width: 117, height: 166, rotation: 0, imageRotation: 0 },
            { id: "2", x: 64, y: 243, width: 117, height: 165, rotation: 0, imageRotation: 0 },
            { id: "3", x: 188, y: 71, width: 263, height: 337, rotation: 0, imageRotation: 0 },
            { id: "4", x: 459, y: 71, width: 114, height: 166, rotation: 0, imageRotation: 0 },
            { id: "5", x: 459, y: 243, width: 114, height: 165, rotation: 0, imageRotation: 0 },
            { id: "6", x: 912, y: 0, width: 362, height: 476, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-06-h0v6-10",
    name: "LA 10 - H0V6",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-06-h0_v6_10.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 0, y: 0, width: 354, height: 476, rotation: 0, imageRotation: 0 },
            { id: "2", x: 696, y: 71, width: 263, height: 337, rotation: 0, imageRotation: 0 },
            { id: "3", x: 967, y: 71, width: 122, height: 166, rotation: 0, imageRotation: 0 },
            { id: "4", x: 967, y: 243, width: 122, height: 165, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1096, y: 71, width: 122, height: 166, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1096, y: 243, width: 122, height: 165, rotation: 0, imageRotation: 0 }
    ],
}
];